import { Box, Text, Image, Heading } from 'pcln-design-system';
import React from 'react';
function generateContentfulImageQueryParams(image) {
  const queryParams = ['fm=webp'];
  if (image?.quality) {
    queryParams.push(`q=${image.quality}`);
  }
  if (image?.width) {
    queryParams.push(`w=${image.width}`);
  }
  if (image?.height) {
    queryParams.push(`h=${image.height}`);
  }
  return queryParams.join('&');
}
export default function MediaSnippet({
  image,
  heading,
  paragraph,
  textAlign = 'center',
  borderRadius,
  height = ['440px', null, null, null, null, '500px']
}) {
  const fastlyQueryParams = generateContentfulImageQueryParams(image);
  return React.createElement(Box, {
    px: 2,
    as: 'section'
  }, React.createElement(Image, {
    src: `${image.asset.file.url}?${fastlyQueryParams}`,
    alt: image.altText,
    loading: 'lazy',
    borderRadius: borderRadius,
    width: '100%',
    objectFit: 'contain',
    height: height
  }), heading && React.createElement(Heading, {
    as: 'h2',
    textStyle: 'heading4',
    py: 2,
    m: 0,
    textAlign: textAlign
  }, heading), paragraph && React.createElement(Text, {
    pb: 3,
    textStyle: 'paragraph',
    textAlign: textAlign
  }, paragraph));
}